module dg.objects {

    function text(): ng.IDirective {
        return {
            restrict: 'A',
            template: '<input type="text" class="form-control" />',
            replace: true
        };
    }

    angular.module('dg.objects')
        .directive('text', text);
}

//module dg.domainObjects {

//    export class TextController {
//        public ngModel: ng.INgModelController;
//        public propMeta: restfulApi.DomainObjectPropertiesMetadata;
//        public value: any;
//        public domainObjectCtrl: objectEditorController;

//        $onInit = () => {
//            this.value = null;
//        }

//        public change() {
//            this.ngModel.$setViewValue(this.value);
//        }
//    }

//    angular.module('dg.objects').component('text', {
//        bindings: {
//            value: '=value',
//            propMeta: '<'
//        },
//        require: {
//            ngModel: 'ngModel',
//            domainObjectCtrl: '^domainObject'
//        },
//        controller: TextController,
//        template: '<input ng-model="$ctrl.value" type="text" class="form-control" ng-change="$ctrl.change()"  />',
//    });
//}      